module.exports = __webpack_public_path__ + "img/avatar7.6fe14074.png";